<template>
    <div>
        <tsoft-table
            :api="tableApiUrl"
            :items.sync="items"
            :isNeedSearch="true"
            :isNeedCreate="isNeedCreate"
            :additionalGetParameter="additionalGetParameter"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
            :customAddButtonName="'Добавить'"
        />

        <create-insurance
            :isSideBarOpenInsurance.sync='isSideBarOpenInsurance'
            :editIndex.sync="editIndex"
            :editedItemExt.sync="editedItem"
            :companyId="companyId"
            @create='setCreatedItem'
            @update='setUpdatedItem'
            @closeSidePanel='setClosedSidePanel'
        />

        <b-sidebar
            v-if="isSidebarOpenDetail"
            v-model="isSidebarOpenDetail"
            id="sidebar-right-insurance"
            width="60em"
            right
            backdrop
            body-class="p-0"
            no-header
            no-close-on-route-change
            no-close-on-backdrop
            lazy        
        >
            <template #default="{ hide }">
                <div class="detail-widget">
                    <div
                        class="detail-widget__field detail-widget__left"
                    >
                    
                        <div class="detail-widget__top">
                            <b-icon-arrow-bar-left
                            class="detail-widget__back cursor-pointer"
                            font-scale="2"
                            @click="hide"
                            />
                            <b-skeleton-wrapper>
                            <div class="d-flex mb-2 flex-wrap align-items-center">
                                <h2 class="title text-light">Полис #{{ detailedItem.id }}</h2>
                            </div>
                
                            <div class="d-flex flex-wrap align-items-center">
                                <h2 class="title text-light">{{ detailedItem.policy_number }}</h2>
                            </div>
                            </b-skeleton-wrapper>
                        </div>  
            
                        <div class="detail-widget__card">
                        <b-overlay class="h-100">
                            <template v-if="detailedItem.id">
                            <b-tabs 
                                lazy
                                nav-class="nav-widget"
                                nav-wrapper-class="p-0"
                            >
                                <b-tab>
                                <template #title>
                                    <div>Детали</div>
                                </template>
                                <insurance-details
                                    :itemId="detailedItem.id"
                                />
                                </b-tab>

                                <!-- <b-tab id='insurance-change-history'>
                                <template #title>
                                    <div>История</div>
                                </template>
                                <h5 class="mb-4">История изменений полиса <span class="text-secondary">{{detailedItem.name}}</span> (#{{detailedItem.id}})</h5>
                                <change-history
                                    :changeHistoryId.sync="detailedItem.id"
                                    :changeModel.sync="model_name"
                                    :changeLoad.sync="changeLoad"
                                />
                                </b-tab> -->
            
                            </b-tabs>
                            </template>
                        </b-overlay>
                        </div>
                    </div>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
    import { API_COMPANY_INSURANCE } from "../constants"
    import createInsurance from "../components/company-insurance/CreatedOrEditedInsurance.vue"
    import ChangeHistory from '../components/logs/ChangeHistory.vue'
    import insuranceDetails from '../components/company-insurance/InsuranceDetails.vue'

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
    } from '../mixins'
    import { mixinDocuments } from '../mixins/mixinDocuments'

    const initialEditedItem = () => ({
        'id': '',
        'creator_user_id': null,
        'company_id': null,
        'insurance_type_id': null,
        'scan_id': null,
        'policy_number': '',
        'policy_date': '',
        'is_available': true,
        'policy_expiry': '',
        'policy_limit': '',
        'case_limit': '',
        'franchise_limit': '',
        'company': null,
        'insurance_type': null,
        'scan': null,
        'new_scan': null,
    })

    export default {
        props: {
            isNeedCreate: { type: Boolean, required: false, default: true },    // If table needs create new element button
            additionalGetParameter: { type: String, required: false, default: '' }, // If we want to add something, for example, &company_id=10
            companyId: { type: Number, required: false, default: -1 }
            // typeOfTableFilter: { type: String, required: false, default: '' },      // Type of filter for output: orders, services
        },
        components: {
            "create-insurance": createInsurance,
            'change-history': ChangeHistory,
            'insurance-details': insuranceDetails,
        },
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            mixinDocuments
        ],
          data() {
            return {
                model_name: ['App\\Models\\Insurance'],
                changeLoad: false,
                isSideBarOpenInsurance: false,
                isSidebarOpenDetail: false,
                tableApiUrl: API_COMPANY_INSURANCE,
            }
        },
        mounted() {
            this.editedItem = initialEditedItem()
            this.initialAssign()
        },
        methods: {
            initialAssign() {
              if (this.companyId) {
                  this.editedItem.company_id = this.companyId
              }
            },
            // rewrite showItem from actions.js
            showItem(index, tabSelector = '', name) {
                let id = this.items.data[index].id;
            
                api.call("get", `${this.tableApiUrl}/${id}`).then(({data}) => {
                    this.detailedItem = data
                    this.isSidebarOpenDetail = true
                    this.detailedItemIndex = index
                    // If this element exist in table lets update
                    if (typeof this.items !== 'undefined' && this.items.data[index]) {
                        this.items.data[index] = Object.assign(this.items.data[index], data)
                    }
                }).finally(() => {
                    if (tabSelector != '') {
                        // $(tabSelector).tab('show')
                        $(tabSelector)[0].click()
                    }
                })
            },

            onCloseSidePanelLoadingDocument(value) {
                if(value == true){
                    this.checkedLoadDocument = false
                }
            },
            // calls from mixin on show sidebar company
            onOpenCompanyModalCallback() {
                this.isSideBarOpenInsurance = true
            },
            setCreatedItem(data) {
                this.items.data.unshift(data)
                this.editedItem = initialEditedItem()
            },
            setUpdatedItem(data) {
                Object.assign(this.items.data[this.editIndex], data)
                this.editedItem = initialEditedItem()
                this.editIndex = -1
            },
            setClosedSidePanel(){
                this.editedItem = initialEditedItem()
                this.editIndex = -1
            },
        }
    }
</script>

<style lang="scss" scoped>
$bg-top: #0d6247;

.buttons {
  display: flex;
  flex-wrap: wrap;
  margin-left: auto;

  @media screen and (max-width: 991px) {
    margin-left: 0;
  }
}

.textarea-form {
  min-width: 400px;
  @media screen and (max-width: 991px) {
    min-width: 100%;
  }
}

.title {
  margin-bottom: 0;

  @media screen and (max-width: 991px) {
    margin-bottom: 0.5rem;
    font-size: 1rem;
    width: 100%;
  }
}

.subtitle {
  @media screen and (max-width: 991px) {
    font-size: 1.1rem;
    margin-left: -40px;
  }
}

.detail-widget {
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;

  @media screen and (max-width: 991px) {
    flex-direction: column;
    position: relative;
  }

  &__left {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    @media screen and (max-width: 991px) {
      min-height: 100vh;
    }
  }

  &__right {
    width: 100%;
    background-color: #f5f5f5;
    position: relative;
    @media screen and (max-width: 991px) {
      max-width: 100% !important;
    }

    &.collapses {
      transition: width 0.3s;
    }
  }

  &__top {
    position: relative;
    color: #fff;
    background-color: $bg-top;
    padding: 15px 1.5rem 15px 3rem;
    min-height: 110px;

    &-copy-button {
      position: absolute;
      top: 65px;
      left: 10px;
      border: none;
      outline: none;
      background-color: transparent;
      color: #fff;
    }
  }

  &__card {
    flex: 1;
    overflow-x: hidden;

    ::v-deep .tabs {
      display: flex;
      height: 100%;
      margin: 0;
      @media screen and (max-width: 991px) {
        flex-direction: column;
      }

      .nav-widget {
        background-color: $bg-top;
        height: 100%;
        flex-wrap: nowrap;
        overflow: auto;
        min-width: 130px;
        width: 100%;
        flex-direction: column;
        @media screen and (max-width: 991px) {
          flex-direction: row;
          height: auto;
          overflow-y: hidden;
        }
        .nav-link {
          text-align: left;
          border-radius: 0 !important;
          padding: 15px 10px !important;
          font-size: 14px !important;
          line-height: 1.1;
          font-weight: 700;
          color: #fff;
          min-width: 100px;
          border: none;
          text-transform: uppercase;
          @media screen and (max-width: 991px) {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            padding: 10px !important;
          }
          &.active {
            color: #000 !important;
            background-color: #fff;
          }
          &:hover {
            color: #000 !important;
            background: #fff;
          }
        }
      }

      .tab-content {
        overflow: auto;
        height: 100%;
        width: 100%;
        padding: 15px 22px;
        @media screen and (max-width: 991px) {
          overflow: inherit;
          padding: 15px 5px;
        }

        &::-webkit-scrollbar {
          width: 7px;
          border-radius: 0 !important;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 0 !important;
          cursor: pointer;
        }
      }
    }
  }

  &__back {
    font-size: 200%;
    position: absolute;
    left: 10px;
    top: 15px;
  }
}
</style>